import { render, staticRenderFns } from "./addNewModal.vue?vue&type=template&id=4a92aec7&scoped=true&"
import script from "./addNewModal.vue?vue&type=script&lang=js&"
export * from "./addNewModal.vue?vue&type=script&lang=js&"
import style0 from "./addNewModal.vue?vue&type=style&index=0&id=4a92aec7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a92aec7",
  null
  
)

export default component.exports